export enum FORM_STATUS {
  REJECTED = 'REJECTED',
  PENDING = 'PENDING',
  FINISHED = 'FINISHED',
  INCOMPLETE = 'INCOMPLETE',
  ERROR = 'ERROR',
  UNDEFINED = 'UNDEFINED',
}
